"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_1 = require("../../../../graphql");
const react_hooks_1 = require("@apollo/react-hooks");
const models_1 = require("@osmosys/models");
const react_hanger_1 = require("react-hanger");
const react_1 = require("react");
exports.useContentMappingDetail = ({ contentMappingId, cmsId, }) => {
    const draft = react_hanger_1.useSetState(new models_1.ContentMapping());
    const resultOfCms = react_hooks_1.useQuery(graphql_1.integration, {
        skip: !cmsId,
        variables: {
            id: cmsId,
        },
    });
    const resultOfContentMapping = react_hooks_1.useQuery(graphql_1.contentMapping, {
        skip: !contentMappingId,
        variables: {
            id: contentMappingId,
        },
    });
    const [save, saveResult] = react_hooks_1.useMutation(graphql_1.updateContentMapping, {
        variables: {
            data: {
                conversionIds: Array.isArray(draft.state.conversions)
                    ? draft.state.conversions.map(c => c.id)
                    : [],
                fields: draft.state.fields || [],
                isArray: draft.state.isArray === true,
                name: draft.state.name,
                pathToArray: draft.state.pathToArray || '',
                pathToDate: draft.state.pathToDate || '',
                pathToTitle: draft.state.pathToTitle || '',
                sampleContentFeedID: draft.state.sampleContentFeed
                    ? draft.state.sampleContentFeed.id
                    : null,
            },
            id: contentMappingId,
        },
    });
    react_1.useEffect(() => {
        if (resultOfContentMapping.data &&
            resultOfContentMapping.data.contentMapping) {
            draft.setState(Object.assign({}, resultOfContentMapping.data.contentMapping));
        }
    }, [resultOfContentMapping.data]);
    const sampleContentItem = react_hanger_1.useNumber(0, {
        lowerLimit: 0,
    });
    const ui = react_hanger_1.useSetState({
        view: 'main',
    });
    return {
        draft,
        resultOfCms,
        resultOfContentMapping,
        sampleContentItem,
        save,
        saveResult,
        ui,
    };
};
//# sourceMappingURL=useContentMappingDetail.js.map